"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("@apollo/client"),t=e.gql`
  mutation saveExperimentTreatment($input: saveExperimentTreatmentInput!) {
    saveExperimentTreatment(input: $input) {
      success
      assignments
      maxAge
      name
    }
  }
`;exports.SaveExperimentTreatmentDocument=t;
